var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccesConfirmation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "auto",
    height: "auto",
    viewBox: "0 0 773.13 421.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3981",
    "data-name": "Trac\\xE9 3981",
    d: "M0,0H165.515V178.581H0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3984",
    "data-name": "Trac\\xE9 3984",
    d: "M0,0H145.915V106.714H0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21899",
    "data-name": "Groupe 21899",
    transform: "translate(-498 -348.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4065",
    "data-name": "Trac\\xE9 4065",
    d: "M106.379,119.8l9.311,7.22,16.082-15.507",
    transform: "translate(590.986 312.127)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3971",
    "data-name": "Trac\\xE9 3971",
    d: "M126.269,473.784S227.193,409.3,125.7,305.033C86.946,265.275,69.717,204.975,82.035,150.779c6.344-27.978,22.1-57.334,45.431-75.622,26.42-20.648,61.93-19.351,93.288-14.288,34.319,5.532,66.376,19.925,95.875,37.942,28.039,17.095,52.466,39.994,80.671,56.407,26.23,15.261,53.842,27.71,83.636,34.147,22.641,4.893,45.977,6.378,68.867,2.446,36-6.18,78.072-19.267,110.748,4.827,54.269,40.026,14.021,121.13-35.1,144.546-20.081,9.568-42.019,14.467-63.061,21.668-47.68,16.392-92.17,56.42-87.837,110.932Z",
    transform: "translate(526.954 290.402)",
    fill: "#ecf4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3972",
    "data-name": "Trac\\xE9 3972",
    d: "M36.215,241.507H765.106",
    transform: "translate(475.875 524.659)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3973",
    "data-name": "Trac\\xE9 3973",
    d: "M295.607,217.582H127.926a7.888,7.888,0,0,1-7.892-7.892V98.633a7.89,7.89,0,0,1,7.892-7.89H295.607a7.888,7.888,0,0,1,7.89,7.888V209.689A7.9,7.9,0,0,1,295.607,217.582Z",
    transform: "translate(582.094 333.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3974",
    "data-name": "Trac\\xE9 3974",
    d: "M295.6,90.743H127.931a7.89,7.89,0,0,0-7.89,7.89V209.689a7.89,7.89,0,0,0,7.89,7.892H295.6a7.89,7.89,0,0,0,7.89-7.892V98.633A7.89,7.89,0,0,0,295.6,90.743Z",
    transform: "translate(582.104 333.605)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3975",
    "data-name": "Trac\\xE9 3975",
    d: "M120.2,135.842V152.1a7.851,7.851,0,0,0,7.89,7.786H295.116a7.852,7.852,0,0,0,7.858-7.786V135.842H120.2Z",
    transform: "translate(582.309 390.757)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3976",
    "data-name": "Trac\\xE9 3976",
    d: "M153.359,147.007l-6.208,31.766s-3.346,12.422,4.775,12.658h77.152s-1.907-5.97-4.773-5.489H192.741s-3.1-1.671-1.914-7.892L197.516,147l-44.157.007Z",
    transform: "translate(615.594 404.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3977",
    "data-name": "Trac\\xE9 3977",
    d: "M195.167,147.007l-6.208,31.766s-3.346,12.422,4.775,12.658h77.152s-1.907-5.97-4.773-5.489H234.549s-3.1-1.671-1.914-7.892L239.323,147l-44.157.007Zm-53.985,51.475-27.7,163.38M251.211,198.02,282.149,361.4M385.118,201.69,357.705,361.315",
    transform: "translate(573.787 404.896)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21896",
    "data-name": "Groupe 21896",
    transform: "translate(498 586.849)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3979",
    "data-name": "Trac\\xE9 3979",
    d: "M183.873,282.3c-21.89,13.229,7.89,55.051,7.89,55.051l-25.316,18.734c-9.867-4.671-15.395-10.291-18.4-15.644l-17.821,20.049c-12.322-.512-25.3-4.627-31.265-16.295-1.886-3.691-2.041-8.5-2.195-13.238-.2-6.183-.4-12.241-4.428-15.517-3.274-2.655-8.028-3.773-12.084-4.485-2.106-.374-14.238-2.471-15.843-.374,8.173-10.679-6.292-3.9-6.292-3.9-4.829-1.637-6.892-11.019-8.468-18.2a51.712,51.712,0,0,0-1.791-6.888c-1.347-3.367-13.88-26.3-17.859-24.863,17.208-6.273,35.732-1.945,50.4,8.4,6.262,4.405,10.325,10.461,13.812,17.17.363.7,1.027,2.353,1.852,4.405,2.217,5.521,5.584,13.9,7.3,14.118,2.514.324,26.7,14.023,41.726,22.645a15.205,15.205,0,0,1,.551-2.233c1.882-5.176-4.6-13.651-4.6-13.651-18.591-16.827-2.907-32.88-2.907-32.88,6.752-6.9,2.834-19.156-2.211-25.6-1.9-2.421-4.927-4.247-7.992-6.092-5.095-3.068-10.277-6.19-10.479-12.189-.113-3.315,1.671-6.174,3.473-9.058a34.093,34.093,0,0,0,2.607-4.711c3.2-7.568-.485-15.782-6.146-21.042-1.177-1.1-2.458-2.129-3.741-3.165-3.609-2.913-7.228-5.836-8.547-10.164-1.791-5.865,1.648-12.4,6.8-15.73s11.581-4.018,17.707-3.766c10.944.447,22.063,3.813,30.25,11.1,11.724,10.429,15.7,27.284,15.014,42.946l0,.052c-.506,11.683-.868,20.036,7.761,28.637.989.982,2.029,1.943,3.072,2.909,5.389,4.983,10.874,10.057,9.817,18.258-.837,6.412-6.307,11.982-11.64,15.2Z",
    transform: "translate(-30 -161.494)",
    fill: "#cde5f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21895",
    "data-name": "Groupe 21895",
    transform: "translate(0 -5.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3980",
    "data-name": "Trac\\xE9 3980",
    d: "M102.339,159.993c2.394,9.3,8.622,15.2,16.15,20.609,4.748,3.412,10.62,6.4,14.114,11.239,5.036,6.983,1.617,13.433,2.353,21.389.415,4.432,1.973,8.917,5.26,11.976,13.059,12.361,20.385,22.285,18.41,41.262-2.773,26.765-4.4,57.386,20.972,74.891M30,260.727a64.9,64.9,0,0,1,41.586,28.5c4.194,6.643,5.509,14.875,12.073,19.682,6.693,4.913,15.537,5.845,23.1,8.831,13.91,5.478,23.371,19.451,28.145,33.174",
    transform: "translate(-30 -159.993)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.218
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21898",
    "data-name": "Groupe 21898",
    transform: "translate(1125.215 658.715)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3982",
    "data-name": "Trac\\xE9 3982",
    d: "M329.923,266.163c12.506,12.059-23.285,33.313-23.285,33.313l23.731,18.2c20.924-4.641,19.07-19.963,19.07-19.963-.467-3.716,5.1-8.357,5.1-8.357C369.4,281,361.419,268,361.419,268c-3.43-5.6,1.007-13.111,5.321-16.637a19.638,19.638,0,0,1,6.226-2.843c3.834-1.265,7.734-2.553,8.767-6.493.562-2.181-.19-4.346-.952-6.532a23.819,23.819,0,0,1-1.022-3.51c-.993-5.5,2.684-10.389,7.235-13.019.936-.544,1.934-1.034,2.929-1.524,2.839-1.394,5.684-2.791,7.217-5.466,2.072-3.618.782-8.47-2.138-11.45s-7.074-4.405-11.177-5.163c-7.3-1.347-15.184-.789-21.7,2.816-9.35,5.16-14.54,15.714-16.44,26.2l0,.029c-1.424,7.822-2.444,13.418-9.459,17.818-.807.506-1.646.991-2.487,1.478-4.315,2.5-8.686,5.024-9.237,10.615-.415,4.378,2.374,8.9,5.426,11.835Zm71.543-.44c-16.347,1.859-49.074,39.6-49.074,39.6l22.772,16.544c9.18-1.782,31.236-14.689,34.405-24.1,1-2.977.587-6.6.177-10.169-.535-4.657-1.061-9.219,1.6-12.123,2.149-2.356,5.589-3.723,8.547-4.7,1.539-.512,10.4-3.433,11.837-2.038-7.319-7.1,4.281-3.623,4.281-3.623,3.442-1.762,3.943-9.026,4.328-14.585a39.248,39.248,0,0,1,.576-5.36c.646-2.7,7.484-21.3,10.627-20.641-13.572-2.793-26.96,2.505-36.825,11.889-4.2,4-6.575,8.99-8.448,14.406-.193.558-.5,1.873-.877,3.505-1.034,4.448-2.614,11.248-3.925,11.4Z",
    transform: "translate(-306.647 -193.374)",
    fill: "#cde5f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21897",
    "data-name": "Groupe 21897",
    transform: "translate(12.406 1.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3983",
    "data-name": "Trac\\xE9 3983",
    d: "M396.027,194.7c-2.986,5.8-8,8.777-13.81,11.23-3.662,1.546-8,2.63-11.041,5.328-4.392,3.866-3.1,8.659-4.786,13.807a12.756,12.756,0,0,1-5.26,7.149c-10.522,6.226-16.873,11.7-18.412,24.572-2.19,18.163-11.18,44.393-30.6,52.172M444.63,224.513a49.17,49.17,0,0,0-28.014,25.98c-2.406,5.444-2.478,11.762-6.858,16.1s-11,6.1-16.34,9.2c-9.817,5.655-23.838,24.035-25.9,34.852",
    transform: "translate(-312.114 -194.699)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.218
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3986",
    "data-name": "Trac\\xE9 3986",
    d: "M182.471,226.12s-3.945,24.627-26.96,29.218",
    transform: "translate(627.053 505.16)",
    fill: "none",
    stroke: "#221715",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3994",
    "data-name": "Trac\\xE9 3994",
    d: "M237.149,104.974H148.922a7.892,7.892,0,0,0-7.89,7.838v44.177a7.892,7.892,0,0,0,7.89,7.838h86.432a7.89,7.89,0,0,0,7.89-7.838V111.03a6.069,6.069,0,0,0-6.088-6.056",
    transform: "translate(608.705 351.64)",
    fill: "#79a4e2",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3995",
    "data-name": "Trac\\xE9 3995",
    d: "M230.94,161.814H146.388a8.822,8.822,0,0,1-8.824-8.831V110.792a8.825,8.825,0,0,1,8.824-8.831H230.94a8.822,8.822,0,0,1,8.824,8.831v42.191a8.827,8.827,0,0,1-8.824,8.831Z",
    transform: "translate(604.309 347.821)",
    fill: "#ebf4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3996",
    "data-name": "Trac\\xE9 3996",
    d: "M196.473,111.663H163.541c-.657,0-1.249-.394-1.249-.868s.567-.875,1.249-.875h32.932c.657,0,1.249.395,1.249.875S197.169,111.663,196.473,111.663Zm-5.589,4.453H163.548c-.657,0-1.256-.395-1.256-.875s.567-.875,1.256-.875h27.336c.658,0,1.249.394,1.249.875S191.573,116.115,190.884,116.115Zm-9.5,4.754H163.126a.882.882,0,0,1,0-1.757h18.256a.882.882,0,0,1,0,1.757Z",
    transform: "translate(635.646 357.906)",
    fill: "#467ef6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3997",
    "data-name": "Trac\\xE9 3997",
    d: "M189.192,130.457H162.713a3.3,3.3,0,0,1-3.249-3.256v-2.709a3.3,3.3,0,0,1,3.249-3.256h26.479a3.292,3.292,0,0,1,3.256,3.256V127.2a3.281,3.281,0,0,1-3.256,3.256Z",
    transform: "translate(632.063 372.247)",
    fill: "#c52b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3998",
    "data-name": "Trac\\xE9 3998",
    d: "M208.575,130.457H182.089a3.292,3.292,0,0,1-3.256-3.256v-2.709a3.281,3.281,0,0,1,3.256-3.256h26.472a3.292,3.292,0,0,1,3.288,3.256V127.2a3.283,3.283,0,0,1-3.288,3.256",
    transform: "translate(656.607 372.247)",
    fill: "#2d994c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3999",
    "data-name": "Trac\\xE9 3999",
    d: "M172.134,122.54l-.605-.6-2.854,2.841-2.859-2.841-.605.6,2.859,2.841-2.859,2.839.605.6,2.859-2.841,2.854,2.841.605-.6-2.861-2.839Zm46.943-.349a4.37,4.37,0,0,0-.342.395c-.163.211-.347.4-.519.612q-.314.39-.657.755c-.236.252-.453.553-.7.816-.138.145-.256.315-.388.474l-.948,1.1c-.222.27-.447.546-.657.816l-.979,1.149-.56.657c0,.034-.052,0-.077,0l-.27-.249c-.159-.152-.317-.3-.467-.46s-.307-.311-.467-.46-.381-.363-.567-.546-.374-.381-.571-.565-.369-.351-.546-.533q-.229-.237-.472-.46c-.054-.045-.079-.079,0-.145s.3-.322.465-.467c.041-.039.066-.039.1,0l.487.467c.222.218.44.447.657.657s.46.429.657.658a5.87,5.87,0,0,0,.565.54l.329.315c.034.041.045.041.086,0,.236-.222.4-.506.657-.73a2.65,2.65,0,0,0,.4-.492c.138-.159.413-.508.657-.744a4.177,4.177,0,0,0,.4-.481c.138-.156.288-.342.44-.512s.4-.492.619-.73.406-.506.623-.737.263-.322.395-.474.3-.34.442-.519a7.621,7.621,0,0,0,.531-.657c.041-.059.066-.045.107,0,.156.145.336.256.481.415l.1.086",
    transform: "translate(639.344 372.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4000",
    "data-name": "Trac\\xE9 4000",
    d: "M323.863,187.07H171.356c-2.8,0-5.062-3.534-5.061-7.892V71.3c0-4.356,2.267-7.886,5.061-7.89H323.863c2.795,0,5.06,3.533,5.061,7.89V179.146c0,4.358-2.266,7.89-5.061,7.89",
    transform: "translate(731.621 298.972)",
    fill: "#79a4e2",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4001",
    "data-name": "Trac\\xE9 4001",
    d: "M329.828,181.814H177.348c-2.795,0-5.061-3.532-5.061-7.89V66.083c0-4.356,2.267-7.886,5.061-7.89H329.828c2.8,0,5.062,3.532,5.062,7.89V173.924C334.891,178.282,332.624,181.815,329.828,181.814Z",
    transform: "translate(739.215 292.356)",
    fill: "#ebf4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4004",
    "data-name": "Trac\\xE9 4004",
    d: "M336.464,79.822H226.471c-2.3,0-4.181-1.446-4.181-3.208s1.88-3.215,4.181-3.215H336.489c2.294,0,4.176,1.447,4.176,3.215s-1.882,3.208-4.176,3.208M329.4,91.358H226.163c-2.158,0-3.945-1.442-3.945-3.21s1.762-3.208,3.945-3.208H329.4c2.149,0,3.945,1.446,3.945,3.208s-1.768,3.208-3.945,3.208Zm-18.235,12.551h-85.65a3.216,3.216,0,1,1,0-6.425h85.65a3.216,3.216,0,1,1,0,6.425ZM329.4,116.456H226.163c-2.158,0-3.945-1.447-3.945-3.208s1.762-3.217,3.945-3.217H329.4c2.149,0,3.945,1.446,3.945,3.217S331.578,116.456,329.4,116.456Z",
    transform: "translate(711.516 311.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4005",
    "data-name": "Trac\\xE9 4005",
    d: "M265.814,85.322a2.876,2.876,0,1,1-.841-2.031A2.868,2.868,0,0,1,265.814,85.322Z",
    transform: "translate(759.533 323.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4006",
    "data-name": "Trac\\xE9 4006",
    d: "M197.71,173.641s-.848-7.305,11.3-11.139c0,0,13.807-5.339,19.725,11.139Z",
    transform: "translate(680.514 423.496)",
    fill: "#467ef6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4007",
    "data-name": "Trac\\xE9 4007",
    d: "M274.487,150.1l-42.23,27.125-8.824-1.519c-.336-.059-1.315-1.551-1.564-1.814a13.527,13.527,0,0,0-4.689-3,12.27,12.27,0,0,0-7.575-.2c-2.013.565-14.014,6.432-11.744,9.7,1.467,2.1,10.645-2.322,12.717-2.789,1.315-.3,2.993-.88,4.188,0a3.394,3.394,0,0,1,1.093,2.532c.2,2.682-2.578,3.38-4.5,4.333a8.248,8.248,0,0,0-2.63,1.893c-.19.231-.979,1.975-1.032,1.975s81.539-10.332,86.758-13.2c0,0-9.711-25.586-19.931-25.067",
    transform: "translate(680.359 408.777)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4008",
    "data-name": "Trac\\xE9 4008",
    d: "M245.188,231.416a14.284,14.284,0,0,1-.177,2.063c-.657,4.453-3.723,15.025-17.855,20.958l34.693-1.131-.3-26.9-15.467-.564-.88,6.353",
    transform: "translate(717.846 504.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4009",
    "data-name": "Trac\\xE9 4009",
    d: "M267.95,237.954l.388,5.491-45.739.467s-1.757-5.124,3.945-5.872l41.407-.086Z",
    transform: "translate(711.746 520.157)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4010",
    "data-name": "Trac\\xE9 4010",
    d: "M239.964,231.4s-3.138,8.681-9.865,12.343",
    transform: "translate(721.574 511.847)",
    fill: "none",
    stroke: "#060000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4011",
    "data-name": "Trac\\xE9 4011",
    d: "M250.089,240.634l-14.776.295.093,4.682,14.776-.295Z",
    transform: "translate(728.182 523.553)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4012",
    "data-name": "Trac\\xE9 4012",
    d: "M263.393,232.81a14.666,14.666,0,0,1,1.485,1.447c3.038,3.328,9.3,12.377,4.972,27.08l21.042-27.62L269.85,216.955l-10.212,11.626,4.367,4.7",
    transform: "translate(759.006 493.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4013",
    "data-name": "Trac\\xE9 4013",
    d: "M288.546,224.351l4.5,3.17L264.5,263.273s-5.07-1.873-2.059-6.752Z",
    transform: "translate(761.354 502.919)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4014",
    "data-name": "Trac\\xE9 4014",
    d: "M263.281,226.41s4.741,7.892,3.346,15.422",
    transform: "translate(763.623 505.528)",
    fill: "none",
    stroke: "#060000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4015",
    "data-name": "Trac\\xE9 4015",
    d: "M279.682,225.136l-9.062,11.67,3.7,2.873,9.062-11.672Z",
    transform: "translate(772.924 503.914)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4016",
    "data-name": "Trac\\xE9 4016",
    d: "M290.239,165.057c-8.942,2.367,1.519,0-7.232,2.145-42.853,9.863-80.519,23.337-71.5,61.812,10.7,45.556,45.5,86.983,45.5,86.983l28.935-1.71s-24.738-78.338-30.6-92l50.462.726c17.53.243,30.9-9.287,46.5-18.322,5.083-2.907,8.226-21.949,12.946-25.368-20.063-12.422-74.962-14.243-74.962-14.243",
    transform: "translate(696.309 427.779)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4017",
    "data-name": "Trac\\xE9 4017",
    d: "M269.04,196.128c-9.205,7.588-18.7,15.125-27.191,23.516-16.755,16.578-24.883,33.607-9.862,53.448,26.96,35.739,72.74,44.2,72.74,44.2l21.312-28.533s-46.2-29.907-56.708-39.534l46.206-20.022c16.059-6.963,31.32-16.526,42.085-30.853a59.616,59.616,0,0,0,8.747-18.2c-2.27-3.328-60.5-16.145-60.5-16.138",
    transform: "translate(713.951 426.456)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4018",
    "data-name": "Trac\\xE9 4018",
    d: "M243.353,279.1s-37.053-30.644-8.18-60.728m100.765-29.136a13.32,13.32,0,0,1-7.693-19.07l25.033,8a13.635,13.635,0,0,1-.526,2.406,13.377,13.377,0,0,1-16.814,8.661Z",
    transform: "translate(714.053 434.248)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4023",
    "data-name": "Trac\\xE9 4023",
    d: "M238.524,133.7c5.045-5.26,12.035-8.06,19.07-9.5,3.879-.789,7.944-.8,11.758-1.893,5.976-1.73,8.983-6.135,12.093-11.232,4.194-6.87,15.841-1.793,11.586,5.169l-.71,1.152a7.03,7.03,0,0,1,.9.551c1.737.737,3.288,2.3,4.525,4.952a11.09,11.09,0,0,1,.558,1.446c3.387.184,9.146-5.319,8.9-.941-1.671,30-38.8,60.59-65.916,43.551-11.908-7.475-12.112-23.5-2.755-33.26",
    transform: "translate(723.859 355.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4024",
    "data-name": "Trac\\xE9 4024",
    d: "M262.009,122.477c5.741,3.655,10.588,1.941,12.9-2.131,2.136-3.786.7-9.81-4.668-10.2a13.654,13.654,0,0,0-6.346,1.242,18.935,18.935,0,0,0-2.63,3.288c-1.5,2.453-2.519,5.72.71,7.786",
    transform: "translate(759.271 358.178)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4025",
    "data-name": "Trac\\xE9 4025",
    d: "M270.66,138.314c-12.211,3.73-19.471-3.945-19.786-14.347-.138-4.6.125-9.627,2.471-13.692a14.912,14.912,0,0,1,9.647-7.53c8.81-1.907,17.669,4.525,19.779,14.349a.647.647,0,0,1,0,.093,18.093,18.093,0,0,1-12.132,21.126",
    transform: "translate(747.861 348.391)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4026",
    "data-name": "Trac\\xE9 4026",
    d: "M262.068,115.218a6.405,6.405,0,0,1,7.291-3.156c.778.211.56,1.447-.215,1.236a5.142,5.142,0,0,0-5.917,2.453c-.39.7-1.533.177-1.145-.533",
    transform: "translate(762.002 360.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4027",
    "data-name": "Trac\\xE9 4027",
    d: "M266.193,115.238,255.507,116.8l2.131,14.6,10.683-1.56-2.129-14.6Z",
    transform: "translate(753.771 364.646)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4028",
    "data-name": "Trac\\xE9 4028",
    d: "M260.892,121.6a1.164,1.164,0,1,0,.1-1.571,1.122,1.122,0,0,0-.1,1.571Zm-5.28,6.854a25.277,25.277,0,0,1-.395-7.346c.066-.716,1.184-.762,1.118-.039a24.056,24.056,0,0,0,.374,7.062C256.847,128.793,255.754,129.146,255.611,128.457Zm16.426-25.627a14.438,14.438,0,0,0-11.177,1.315c-4.657,2.743-9.865,6.491-10.955,9.686s1.92,5.834,3.99,4.768c6.221-4.163,13.066-9.522,18.111-15.782",
    transform: "translate(746.379 348.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4029",
    "data-name": "Trac\\xE9 4029",
    d: "M277.668,123.334c-1.709,4.643-25.935-11.046-25.534-12.066a14.934,14.934,0,0,1,5.879-7.371c7.613-4.741,20.51-3.117,23.711,10.572,2.138,8.069-2.977,7.892-4.056,8.865Z",
    transform: "translate(749.492 347.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4030",
    "data-name": "Trac\\xE9 4030",
    d: "M266.548,125.858h3.19a6.521,6.521,0,0,0,6.523-6.53v-3.19a6.525,6.525,0,0,0-6.523-6.523h-3.19a6.525,6.525,0,0,0-6.53,6.523v3.19A6.53,6.53,0,0,0,266.548,125.858Z",
    transform: "translate(759.488 357.521)",
    fill: "#1c49c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4032",
    "data-name": "Trac\\xE9 4032",
    d: "M266.648,121.875a5.478,5.478,0,1,0-5.478-5.478,5.478,5.478,0,0,0,5.478,5.478Z",
    transform: "translate(760.947 359.175)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4033",
    "data-name": "Trac\\xE9 4033",
    d: "M240.069,194.423c1.46-16.27,4.689-51.081,41.874-63.784a28.731,28.731,0,0,1,7.675-1.934c38.881-5.371,55.6,4.945,71.273,17.755,33.34,27.316,3.63,103.028,3.63,103.028h0c1.855,16-.356-6.312,0,0-31.964-8.613-60.411-19.2-95.723-17.814-.3,0,.342-10.067.435-11.177-.238,2.852-4.65,4.043-6.865,4.707-8.148,2.46-16.349,3.072-24.779,3.616-.658.041-10.021.605-9.863-.322a59.845,59.845,0,0,0,1.505-12.551,27.327,27.327,0,0,0-.834-7.044c-.159-.592-2.065-5.918-2.954-5.537,5.972-3.458,14.612-8.942,14.612-8.942",
    transform: "translate(715.674 362.031)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4035",
    "data-name": "Trac\\xE9 4035",
    d: "M251.433,126.638c.243,3.335,8.028,5.471,17.385,4.782s16.748-3.945,16.5-7.294-8.035-5.471-17.392-4.773-16.741,3.945-16.492,7.285Z",
    transform: "translate(748.602 369.693)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4036",
    "data-name": "Trac\\xE9 4036",
    d: "M356.863,169.339s8.18,43.234,6.357,74.626M305.854,117.521s-5.754,4.228-14.723,2.283M226.458,223.022s40.239,2.63,44.3-11.277",
    transform: "translate(716.959 367.539)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4037",
    "data-name": "Trac\\xE9 4037",
    d: "M465.442,200.041H103.561V190.006H465.442Zm83.548-36.856-6,19.142c-2.517,8.035-4.36,16.53-12.263,21.042-6.056,3.444-13.2,3.451-19.845,4.9a33.836,33.836,0,0,0-16.78,9.207c-9.1,8.942-13.751,21.62-16.578,33.8q-.71,3.072-1.27,6.176h57.327l23.672-87.788s6.09-29.735-19.727-18.628c0,0-30.814,26.874-35.469,36.548",
    transform: "translate(561.219 406.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4038",
    "data-name": "Trac\\xE9 4038",
    d: "M340.677,163.184l-6,19.142c-2.517,8.035-4.36,16.53-12.263,21.042-6.056,3.444-13.2,3.451-19.845,4.9a33.835,33.835,0,0,0-16.78,9.207c-9.1,8.942-13.751,21.62-16.578,33.8q-.71,3.072-1.27,6.176h57.327l23.672-87.788s6.09-29.735-19.727-18.628c0,0-30.814,26.874-35.469,36.548m-10.758,69.82-13.34,50.43m47.345-50.43,29.3,101.865",
    transform: "translate(769.531 406.875)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4043",
    "data-name": "Trac\\xE9 4043",
    d: "M238.524,133.69c5.045-5.262,12.035-8.062,19.07-9.5,3.879-.789,7.944-.789,11.758-1.9,5.976-1.728,8.983-6.135,12.093-11.23,4.194-6.872,15.841-1.8,11.586,5.174l-.71,1.145a7.03,7.03,0,0,1,.9.551c1.737.737,3.288,2.3,4.525,4.952a11.76,11.76,0,0,1,.558,1.446c3.387.193,9.146-5.319,8.9-.939-1.671,30-38.8,60.594-65.916,43.556-11.908-7.482-12.112-23.5-2.755-33.265",
    transform: "translate(723.859 355.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4044",
    "data-name": "Trac\\xE9 4044",
    d: "M262.009,122.468c5.741,3.657,10.588,1.941,12.9-2.131,2.136-3.786.7-9.8-4.668-10.2a13.773,13.773,0,0,0-6.346,1.242,19.016,19.016,0,0,0-2.63,3.287c-1.5,2.453-2.519,5.729.71,7.786",
    transform: "translate(759.271 358.167)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4045",
    "data-name": "Trac\\xE9 4045",
    d: "M270.66,138.3c-12.211,3.727-19.471-3.945-19.786-14.349-.138-4.6.125-9.627,2.471-13.69a14.9,14.9,0,0,1,9.647-7.53c8.81-1.907,17.669,4.525,19.779,14.349a.616.616,0,0,1,0,.091A18.088,18.088,0,0,1,270.66,138.3Z",
    transform: "translate(747.861 348.369)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4046",
    "data-name": "Trac\\xE9 4046",
    d: "M262.068,115.218a6.405,6.405,0,0,1,7.291-3.165c.778.218.56,1.453-.215,1.238a5.142,5.142,0,0,0-5.917,2.453c-.39.7-1.533.177-1.145-.526",
    transform: "translate(762.002 360.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4047",
    "data-name": "Trac\\xE9 4047",
    d: "M266.191,115.232l-10.686,1.56,2.131,14.6,10.683-1.558-2.129-14.6Z",
    transform: "translate(753.77 364.639)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4048",
    "data-name": "Trac\\xE9 4048",
    d: "M260.892,121.595a1.168,1.168,0,1,0,.1-1.571,1.116,1.116,0,0,0-.1,1.571Zm-5.283,6.858a25.437,25.437,0,0,1-.394-7.346c.066-.716,1.186-.769,1.118-.045a24.131,24.131,0,0,0,.376,7.062C256.847,128.782,255.754,129.138,255.609,128.453Zm16.428-25.631a14.453,14.453,0,0,0-11.177,1.315c-4.657,2.748-9.865,6.489-10.955,9.686s1.92,5.831,3.99,4.766c6.221-4.16,13.066-9.513,18.111-15.78",
    transform: "translate(746.379 348.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4049",
    "data-name": "Trac\\xE9 4049",
    d: "M277.668,123.332c-1.709,4.643-25.935-11.053-25.534-12.073a14.934,14.934,0,0,1,5.879-7.371c7.613-4.741,20.51-3.117,23.711,10.574,2.138,8.074-2.977,7.89-4.056,8.869Z",
    transform: "translate(749.492 347.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4053",
    "data-name": "Trac\\xE9 4053",
    d: "M251.433,126.637c.243,3.326,8.028,5.464,17.385,4.773s16.748-3.945,16.5-7.291-8.035-5.471-17.392-4.775-16.741,3.945-16.492,7.294Z",
    transform: "translate(748.602 369.682)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4054",
    "data-name": "Trac\\xE9 4054",
    d: "M320.715,169.326s8.18,43.236,6.357,74.628M269.706,117.515s-5.754,4.222-14.724,2.276",
    transform: "translate(753.107 367.532)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4055",
    "data-name": "Trac\\xE9 4055",
    d: "M148.391,159.976l44.919-4.6,1.8-8.377H150.921Z",
    transform: "translate(618.029 404.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4056",
    "data-name": "Trac\\xE9 4056",
    d: "M210.341,176.714s-16.308,18.918.163,38.69",
    transform: "translate(687.412 442.551)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4057",
    "data-name": "Trac\\xE9 4057",
    d: "M257.45,119.221s-9.055,3.242-13.354,11.481M228.91,301.487s-7.024,19.358,17.755,35.133",
    transform: "translate(718.902 369.693)",
    fill: "none",
    stroke: "#ecf4fd",
    strokeWidth: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4061",
    "data-name": "Trac\\xE9 4061",
    d: "M178.656,122.945a8.05,8.05,0,0,0-.258,1.349,13.747,13.747,0,0,1-24.171,5.859.544.544,0,0,0-.467-.211h-4.775a.7.7,0,0,1-.617-.222.558.558,0,0,1-.079-.612.612.612,0,0,1,.612-.356h4.26c.045-.125-.052-.19-.1-.27a12.6,12.6,0,0,1-1.281-3,.324.324,0,0,0-.136-.229.313.313,0,0,0-.122-.054.342.342,0,0,0-.136,0H144.3a1.729,1.729,0,0,1-.342,0,.594.594,0,0,1-.526-.605.576.576,0,0,1,.54-.565h7.108c.265,0,.311-.039.27-.315a13.438,13.438,0,0,1,1.83-9.128v-.045c0-.048-.218,0-.322,0h-3.947a.6.6,0,0,1-.657-.453.558.558,0,0,1,.3-.657.848.848,0,0,1,.467-.066h4.707a.615.615,0,0,0,.292-.05.6.6,0,0,0,.229-.188,13.386,13.386,0,0,1,11.42-5.07A13.619,13.619,0,0,1,178.352,118.8c.1.474.159.966.231,1.447,0,.059,0,.145.073.172v2.523Zm-18.492-1.315v7.516c0,.283,0,.553.308.705a.694.694,0,0,0,.764-.113l11.617-7.509c.592-.381.587-.821,0-1.211l-11.6-7.462a.716.716,0,0,0-.8-.127c-.281.159-.3.422-.3.705v7.516",
    transform: "translate(611.748 355.5)",
    fill: "#2d994c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4062",
    "data-name": "Trac\\xE9 4062",
    d: "M146.437,112.463h2.249c.44,0,.73.243.716.605s-.277.571-.71.571h-4.564c-.433,0-.689-.224-.689-.585a.588.588,0,0,1,.657-.592h2.3",
    transform: "translate(611.756 361.13)",
    fill: "#2d994c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4063",
    "data-name": "Trac\\xE9 4063",
    d: "M159.094,130.748a10.766,10.766,0,1,0-10.766-10.766A10.766,10.766,0,0,0,159.094,130.748Z",
    transform: "translate(617.949 357.015)",
    fill: "#2d994c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4067",
    "data-name": "Trac\\xE9 4067",
    d: "M106.379,116.626l5.743,4.453,9.919-9.564",
    transform: "translate(662.086 360.658)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.43
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesConfirmation);
export default __webpack_public_path__ + "static/media/succesConfirmation.0f6ac940cd5fc39e48d998a792ee02e5.svg";
export { ForwardRef as ReactComponent };